// extracted by mini-css-extract-plugin
export default {"el":"arrows_el__ihN8y","prev":"arrows_prev__GBMOi","slide":"arrows_slide__ow6-W"};